import React, { memo, forwardRef } from "react";
const SvgAlphabetJ = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.5 7.89c0 .413-.153.76-.46 1.04-.293.267-.66.4-1.1.4-.44 0-.807-.14-1.1-.42a1.432 1.432 0 01-.42-1.02c0-.387.14-.72.42-1 .293-.293.66-.44 1.1-.44.44 0 .807.14 1.1.42.307.267.46.607.46 1.02zm-3.72 17.66c-.427 0-.747-.1-.96-.3a.997.997 0 01-.32-.76c0-.307.093-.553.28-.74.173-.187.42-.28.74-.28.52 0 .853-.18 1-.54.16-.347.24-.8.24-1.36v-9.26c0-.28.04-.507.12-.68a1.2 1.2 0 01.32-.42c.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v9.02c0 .56-.047 1.093-.14 1.6-.093.52-.267.973-.52 1.36-.253.387-.6.693-1.04.92-.44.227-1 .34-1.68.34z"
      />
    </svg>
  );
});
SvgAlphabetJ.displayName = "SvgAlphabetJ";
const MemoForwardRef = memo(SvgAlphabetJ);
export default MemoForwardRef;
